import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const us = r => require.ensure([], () => r(require('@/pages/us')), 'us')
const serve = r => require.ensure([], () => r(require('@/pages/serve')), 'serve')
const contact = r => require.ensure([], () => r(require('@/pages/contact')), 'contact')
const casedetail = r => require.ensure([], () => r(require('@/pages/casedetail')), 'casedetail')
const casea = r => require.ensure([], () => r(require('@/pages/case')), 'casea')
const usindex1 = r => require.ensure([], () => r(require('@/pages/us/index1')), 'usindex1')
const usindex2 = r => require.ensure([], () => r(require('@/pages/us/index2')), 'usindex2')
const usindex3 = r => require.ensure([], () => r(require('@/pages/us/index3')), 'usindex3')
const usindex4 = r => require.ensure([], () => r(require('@/pages/us/index4')), 'usindex4')
const usindex5 = r => require.ensure([], () => r(require('@/pages/us/index5')), 'usindex5')

const serindex1 = r => require.ensure([], () => r(require('@/pages/ser/index1')), 'serindex1')
const serindex2 = r => require.ensure([], () => r(require('@/pages/ser/index2')), 'serindex2')
const serindex3 = r => require.ensure([], () => r(require('@/pages/ser/index3')), 'serindex3')
const serindex4 = r => require.ensure([], () => r(require('@/pages/ser/index4')), 'serindex4')
const serindex5 = r => require.ensure([], () => r(require('@/pages/ser/index5')), 'serindex5')

export default new Router({
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
      },
    routes: [{
        path: '/',
        alias: '/us',
        component: us,
    },
    {
        path: '/us',
        name: 'us',
        component: us,
    },
    {
        path: '/usindex1',
        name: 'usindex1',
        meta: { fade: 'er' },
        component: usindex1,
    },
    {
        path: '/usindex2',
        name: 'usindex2',
        meta: { fade: 'er' },
        component: usindex2,
    },
    {
        path: '/usindex3',
        name: 'usindex3',
        meta: { fade: 'er' },
        component: usindex3,
    },
    {
        path: '/usindex4',
        name: 'usindex4',
        meta: { fade: 'er' },
        component: usindex4,
    },
    {
        path: '/usindex5',
        name: 'usindex5',
        meta: { fade: 'er' },
        component: usindex5,
    },
    {
        path: '/serve',
        name: 'serve',
        component: serve,
    },
    {
        path: '/serindex1',
        name: 'serindex1',
        meta: { fade: 'er' },
        component: serindex1,
    },
    {
        path: '/serindex2',
        name: 'serindex2',
        meta: { fade: 'er' },
        component: serindex2,
    },
    {
        path: '/serindex3',
        name: 'serindex3',
        meta: { fade: 'er' },
        component: serindex3,
    },
    {
        path: '/serindex4',
        name: 'serindex4',
        meta: { fade: 'er' },
        component: serindex4,
    },
    {
        path: '/serindex5',
        name: 'serindex5',
        meta: { fade: 'er' },
        component: serindex5,
    },
    {
        path: '/contact',
        name: 'contact',
        component: contact,
    },
    {
        path: '/case',
        name: 'case',
        component: casea,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/casedetail/:id',
        name: 'casedetail',
        meta: {
            fade: 'detail'
        },
        component: casedetail
    }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js